import React, { useState,useContext,useEffect } from "react";
import { isMobile } from "react-device-detect";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import ThumbnailList from "./Components/Thumbnail/ThumbnailList";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import ViewportContext from "../../context/studyviewer/ViewportContext";
import ViewportLayout from "./Components/Viewport/ViewportLayout";
import MobileToolbar from "./Components/Toolbar/MobileToolbar";
import MobileViewerContext from "../../context/studyviewer/MobileViewerContext";
import MobileBottomSheet from "./Components/Toolbar/MobileBottomSheet";
import ReturnStudyModal from "./Components/ReturnStudyModal/ReturnStudyModal";
import MobileHistoryBottomSheet from "./Components/AttachmentBox/MobileHistoryBottomSheet";
import CommunicationModal from "../Communication/CommunicationModal";
import ThumbnailContext from "../../context/studyviewer/ThumbnailContext";
import ShareStudyContext from "../../context/sharestudy/ShareStudyContext";
import ShareStudyLink from "../StudyList/components/Actions/ShareStudyLink";
import MobileOverlayBottomSheet from "./Components/Overlays/MobileOverlayBottomSheet";
import MobileReportOverlay from "./Components/Overlays/MobileReportOverlay";
import TopBar from "./Components/TopBar";
import userContext from "../../context/users/UserContext";
import { USERTYPES } from "../../constants/Constants"; 

const MobileViewer = (props) => {
  const { roles, privilegedFirmDoctor } = useContext(userContext);
  const { isClientReportExist, getData,seriesMenu ,allReportTemplatesLoading } = useContext(studyReportContext);
  const {
    dataGathered,
    patientStudyData,
    studyData,
    priorStudyData,
    studyParentId,
    setMessageCount,
    assignmentData,
    studyModality,
  } = useContext(studyviewerContext);
  const {
    isMPRActive,
    isCompareActive,
    isUserInfoClicked,
    viewportSeriesData,
  } = useContext(ViewportContext);
  const {
    showMobileReportModal, 
    setShowMobileReportModal, 
    openMoreOptions, 
    showHistory,
    slideReportOpen, 
    setSlideReportOpen 
    } = useContext(MobileViewerContext);
  const {
    showReturnStudyModal,
    setShowReturnStudyModal,
    showCommunicationModal,
    hideCommnunicationModal,
  } = useContext(studyReportContext);
  const { showShareStudyLinkModal, setShowShareStudyLinkModal } =
    useContext(ShareStudyContext);
  const { activeStudyId } = useContext(ThumbnailContext);

  const checkForChildStudy = () => {
    if (
      activeStudyId !== "" &&
      studyParentId !== null &&
      studyParentId !== undefined
    ) {
      if (activeStudyId === studyParentId) {
        return false;
      } else {
        return true;
      }
    }
  };
  useEffect(() => {
    if (
      roles.length !== 0 && 
      studyParentId !== null &&
      dataGathered && 
      isClientReportExist != null
    ) {
      if (!roles[0].includes(USERTYPES.FIRMDOCTOR) || privilegedFirmDoctor) {
        console.log("--- Running getData from MobileViewer -----", studyParentId);
        getData(false);
      }
    }
  }, [roles, studyParentId, dataGathered, isClientReportExist]);
  return (
    <>
      <div
        id="viewport-div"
        style={{
          //height: "92%",
          height: "calc(100% - 50px)",
        }}
      >
        <div
          className={
            `${
              isMobile
                ? "first-comes mobile-sidebar-left mobile-thumbnail-list"
                : "first-comes sidebarMenu sidebar-left"
            }` + (seriesMenu === true ? " sidebar-open-left" : "")
          }
        >
          {dataGathered && (
            <ThumbnailList
              patientName={patientStudyData?.patientName}
              patientId={patientStudyData?.patientId}
              studyData={studyData}
              priorStudyData={priorStudyData}
              priors={props.priors}
            />
          )}
        </div>
        <div
          className="h100"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div style={{ height: "92%" }}>
            <div className="viewer-viewport-section h100">
              <div className="main-container h100 w100">
                <div
                  style={{
                    border: `${
                      isMPRActive || isCompareActive ? "1px solid #FFB801" : ""
                    }`,
                    borderRadius: `${
                      isMPRActive || isCompareActive ? "10px" : ""
                    }`,
                    width: "100%",
                    margin: "0px 0.25%",
                    height: "99.5%",
                    position: "relative",
                  }}
                >
                  <ViewportLayout priors={props.priors} />
                </div>
              </div>
            </div>
          </div>
          <div className="viewer-mobile-toolbar">
            <MobileToolbar />
          </div>
        </div>
        <div className={`popup ${openMoreOptions ? "viewer-open" : ""}`}>
          <MobileBottomSheet />
        </div>
        {showReturnStudyModal && (
          <ReturnStudyModal
            setShowReturnStudyModal={setShowReturnStudyModal}
            showReturnStudyModal={showReturnStudyModal}
          />
        )}
        <div className={`popup ${showHistory ? "viewer-open" : ""}`}>
          <MobileHistoryBottomSheet />
        </div>
        {studyParentId !== undefined && <div
          className={`popup ${showCommunicationModal ? "viewer-open" : ""}`}
          style={{ height: "100%" }}
        >
          <CommunicationModal
            isModalOpen={showCommunicationModal}
            hideModal={hideCommnunicationModal}
            studyParentId={studyParentId}
            activeStudyId={activeStudyId}
            child={checkForChildStudy()}
            setMessageCount={setMessageCount}
            studylist={false}
          />
        </div>}

        {showShareStudyLinkModal && (
          <ShareStudyLink
            studyId={studyParentId}
            firmId={assignmentData.firmId}
            clientId={assignmentData.clientId}
            setShowShareStudyLinkModal={setShowShareStudyLinkModal}
          />
        )}
        {/* )} */}
        <div className={`popup ${isUserInfoClicked ? "viewer-open" : ""}`}>
          <MobileOverlayBottomSheet viewportData={viewportSeriesData[0]} />
        </div>
      </div>
      <div className={` viewer-right ${slideReportOpen ? "viewer-open" : ""}`}>
      {/* ✅ Mobile Report Overlay */}
      {isMobile  && (
        <MobileReportOverlay
          isOpen={slideReportOpen}
          onClose={() => setSlideReportOpen(false)}
          readOnly={true}
          modality={studyModality}
          //patientId={patientId}
        />
       )} 
      </div>
    </>
  );
};

export default MobileViewer;
